import { render, staticRenderFns } from "./sopRecallLC.vue?vue&type=template&id=2438bda0&"
import script from "./sopRecallLC.vue?vue&type=script&lang=js&"
export * from "./sopRecallLC.vue?vue&type=script&lang=js&"
import style0 from "./sopRecallLC.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports